<div class="block-container" [ngClass]="colorScheme" (click)="rerouteOnClick()">
  <div class="site-name">
    {{ scheduleInfo.accountName }}
  </div>
  <div class="service-item" *ngFor="let service of scheduleInfo.services">
    <div class="caption-text">
      <span class="count">{{ service.count }}</span> {{ service.debris }} :
      {{ service.accountServiceEquipment }}
    </div>
  </div>
</div>
